import NavbarWithBackButton from './NavbarWithBackButton'

export default NavbarWithBackButton
